<template>
    <div>
        <article class="resume-wrapper text-center position-relative">
            <div class="resume-wrapper-inner mx-auto text-left bg-white shadow-lg position-relative">
                <ul class="resume-languages">
                    <li><a href="#" :title="description" @click.prevent="switchLanguage"><i class="fa fa-language"></i></a>
                    </li>
                </ul>
                <author/>
                <div class="resume-body p-5">
                    <router-view></router-view>
                </div>
            </div>
        </article>
        <project-footer/>
    </div>
</template>
<script>
    import "./sass/theme.sass";
    import Author from "./components/sections/Author";
    import ProjectFooter from "./components/sections/ProjectFooter";

    export default {
        name: "App",
        components: {ProjectFooter, Author},
        data() {
            return {
                askedPwa: false,
                languages: [
                    "pt-br",
                    "en"
                ],
                descriptions: {
                    "pt-br": "Read it on English",
                    "en": "Leia em Português"
                }
            }
        },
        methods: {
            switchLanguage() {
                let currentIndex = this.languages.indexOf(this.$store.state.config.lang);
                let nextIndex = (currentIndex + 1) % this.languages.length;
                this.$router.push({path: "/" + (nextIndex ? "lang/" + this.languages[nextIndex] : "")});
            },
            setPageTitle() {
                document.title = this.author.name + " | " + this.author.i18n[this.lang].function;
            },
            loadLanguage() {
                let lang = this.languages[0];
                if (this.$route.params && this.$route.params.language && this.languages.indexOf(this.$route.params.language) >= 0) {
                    lang = this.$route.params.language;
                }
                this.$store.dispatch("config/setLang", lang);
                this.setPageTitle();
            }
        },
        watch: {
            $route() {
                this.loadLanguage();
            }
        },
        computed: {
            lang() {
                return this.$store.state.config.lang;
            },
            translations() {
                return this.$store.state.config.i18n[this.lang];
            },
            description() {
                return this.descriptions[this.$store.state.config.lang];
            },
            author() {
                return this.$store.state.author;
            }
        },
        created() {
            this.$on("canInstall", (event) => {
                // Prevent Chrome >=67 from automatically showing the prompt:
                event.preventDefault();
                if (!this.askedPwa) {
                    this.askedPwa = true;
                    window.setTimeout(() => event.prompt(), 600);
                }
            });
        },
        mounted() {
            this.loadLanguage();
        }
    }
</script>
<style lang="sass" scoped>
    @import "./sass/constants"
    .resume
        &-wrapper
            padding-top: 30px
            padding-bottom: 60px
            @media (max-width: $mobile)
                padding-top: 0

            &-inner
                max-width: $page-max-width

        &-languages
            list-style: none
            margin: 0
            padding: 0
            position: absolute
            top: -5px
            right: 5px

            a
                color: $light-purple
                text-decoration: none
                font-size: 22px
</style>